module.exports = __webpack_public_path__ + "img/icon-nav-finance.2edd833.svg";